import { createStyles } from "@material-ui/core";
export var styles = function (_a) {
    var spacing = _a.spacing;
    return createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            gap: spacing(2)
        }
    });
};
